module.exports = __webpack_public_path__ + "img/socialising.2daade5c.svg";